module.exports = "https://cdn-assessment.mathletics.com/app/96/assets/images/d4ab9ae32d662b18abeceff5e5654ea9.svg";